module.exports = __webpack_public_path__ + "img/metalMaterialsScience.c2e7fda4.jpg";